/**
 * Tracking event fired when a petition dashboard task is completed.
 * Shared between the AI-guidance (personalizedTasks) and generic task-completion flows.
 */
export const PERSONALIZED_TASKS_COMPLETION_EVENT = 'petition_manage_tasks_completed';
